document.addEventListener("DOMContentLoaded", function () {
  const offers = {
    "2x20":   { required: 2, sizes: ["20ml"],          price: "₹1,000", mrp: "₹1,398", savings: "Save ₹398", special: false },
    "3x20":   { required: 3, sizes: ["20ml"],          price: "₹1,450", mrp: "₹2,097", savings: "Save ₹647", special: false },
    "20+100": { required: 2, sizes: ["20ml", "100ml"], price: "₹2,950", mrp: "₹3,498", savings: "Save ₹548", special: true }
  };

  let currentOffer = "2x20";
  let selected = [];

  const offerButtons = document.querySelectorAll(".offer-btn");
  const basket = document.getElementById("basket-items");
  const progress = document.getElementById("bundle-progress");
  const checkoutBtn = document.getElementById("bundle-checkout");
  const bundlePrice = document.getElementById("bundle-price");
  const bundleMrp = document.getElementById("bundle-mrp");
  const bundleSavings = document.getElementById("bundle-savings");
  const productGrid = document.querySelector(".bundle-products");
  const toast = document.getElementById("bundle-toast");

  const modal = document.getElementById("product-modal");
  const modalClose = document.getElementById("modal-close");
  const modalImage = document.getElementById("modal-image");
  const modalTitle = document.getElementById("modal-title");
  const modalSize = document.getElementById("modal-size");
  const modalStars = document.getElementById("modal-stars");
  const modalDesc = document.getElementById("modal-desc");
  const modalNotes = document.getElementById("modal-notes");
  const modalAddBtn = document.getElementById("modal-add-btn");
  const modalThumbs = document.getElementById("modal-thumbs");
  const modalCollapsibles = document.getElementById("modal-collapsibles");

  function normalizeSize(str) {
    return (str || "").replace(/\s+/g, "").toLowerCase();
  }

  function escapeHTML(str) {
    return (str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function showToast(msg, type = "success") {
    if (!toast) return;
    toast.textContent = msg;
    toast.className = "bundle-toast show " + type;
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove("show"), 3200);
  }

  function renderStarsHTML(rating, count, scale) {
    if (!rating || rating === "") return "";

    const num = parseFloat(rating);
    if (isNaN(num)) return "";

    const maxScale = parseFloat(scale) || 5;
    const decimal = num % 1;
    let ratingDecimal = 0;

    if (decimal >= 0.3 && decimal <= 0.7) ratingDecimal = 0.5;
    else if (decimal > 0.7) ratingDecimal = 1;

    const floorRating = Math.floor(num);

    const countHTML = count
      ? `<span class="card-rating-text">${num.toFixed(1)} <span class="card-rating-count">(${escapeHTML(String(count))})</span></span>`
      : `<span class="card-rating-text">${num.toFixed(1)}</span>`;

    return `
      <div class="rating" role="img" aria-label="${num} out of ${maxScale} stars">
        <span
          aria-hidden="true"
          class="rating-star"
          style="--rating:${floorRating};--rating-max:${maxScale};--rating-decimal:${ratingDecimal};"
        ></span>
      </div>
      ${countHTML}
    `;
  }

  function parseNotes(raw) {
    if (!raw) return [];

    const cleaned = raw
      .replace(/\s+/g, " ")
      .replace(/TOP NOTES\s*:/gi, "|||TOP NOTES:")
      .replace(/MIDDLE NOTES\s*:/gi, "|||MIDDLE NOTES:")
      .replace(/HEART NOTES\s*:/gi, "|||HEART NOTES:")
      .replace(/BASE NOTES\s*:/gi, "|||BASE NOTES:")
      .trim();

    const chunks = cleaned.split("|||").map((p) => p.trim()).filter(Boolean);
    const sections = [];

    chunks.forEach((chunk) => {
      const idx = chunk.indexOf(":");
      if (idx === -1) return;

      const label = chunk.slice(0, idx).trim();
      const value = chunk.slice(idx + 1).trim();
      const items = value.split(",").map((i) => i.trim()).filter(Boolean);

      if (label && items.length) {
        sections.push({ label, items });
      }
    });

    if (!sections.length) {
      const fallback = raw.split(/,|\n/).map((s) => s.trim()).filter(Boolean);
      if (fallback.length) sections.push({ label: "Notes", items: fallback });
    }

    return sections;
  }

  function renderNotesListHTML(notesRaw, limit = 3) {
    const sections = parseNotes(notesRaw);
    if (!sections.length) return "";
    return sections[0].items.slice(0, limit).map((n) => `<li>${escapeHTML(n)}</li>`).join("");
  }

  function renderNotesModalHTML(notesRaw) {
    const sections = parseNotes(notesRaw);
    if (!sections.length) return "";

    return sections.map((sec) => `
      <div class="modal-notes-section">
        <span class="modal-notes-label">${escapeHTML(sec.label)}</span>
        <ul class="modal-notes-list">
          ${sec.items.map((n) => `<li>${escapeHTML(n)}</li>`).join("")}
        </ul>
      </div>
    `).join("");
  }

  function safeParseGallery(raw) {
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function renderModalGallery(gallery, fallbackImage, fallbackAlt) {
    if (!modalImage || !modalThumbs) return;

    let images = gallery && gallery.length ? [...gallery] : [];

    if (fallbackImage) {
      const firstMain = images[0]?.main || "";
      if (firstMain !== fallbackImage) {
        images.unshift({
          thumb: fallbackImage,
          main: fallbackImage,
          alt: fallbackAlt || ""
        });
      }
    }

    if (!images.length) {
      images = [{
        thumb: fallbackImage || "",
        main: fallbackImage || "",
        alt: fallbackAlt || ""
      }];
    }

    modalImage.src = images[0].main;
    modalImage.alt = images[0].alt || fallbackAlt || "";

    modalThumbs.innerHTML = images.map((img, index) => `
      <button
        class="modal-thumb ${index === 0 ? "active" : ""}"
        type="button"
        data-main="${escapeHTML(img.main || "")}"
        data-alt="${escapeHTML(img.alt || "")}"
      >
        <img src="${escapeHTML(img.thumb || img.main || "")}" alt="${escapeHTML(img.alt || "")}">
      </button>
    `).join("");

    modalThumbs.querySelectorAll(".modal-thumb").forEach((btn) => {
      btn.addEventListener("click", () => {
        modalImage.src = btn.dataset.main || "";
        modalImage.alt = btn.dataset.alt || "";

        modalThumbs.querySelectorAll(".modal-thumb").forEach((b) => {
          b.classList.remove("active");
        });
        btn.classList.add("active");
      });
    });
  }

  function renderSingleCollapsible(title, content) {
  if (!content || !content.trim()) return "";
  const safe = escapeHTML(content.trim());
  return `<div class="modal-collapsible">
    <button class="modal-collapsible-toggle" type="button" aria-expanded="false">
      <span>${escapeHTML(title)}</span>
      <span class="modal-collapsible-icon">+</span>
    </button>
    <div class="modal-collapsible-content">
      <div class="modal-collapsible-content-inner">${safe}</div>
    </div>
  </div>`;
}

  function renderModalCollapsibles(card) {
  if (!modalCollapsibles) return;

  const smell = (card.dataset.smell || "").trim();
  const feel = (card.dataset.feel || "").trim();
  const description = (card.dataset.productDescription || "").trim();
  const shipping = (card.dataset.shipping || "").trim();
  const whenToWear = (card.dataset.whenToWear || "").trim();

  modalCollapsibles.innerHTML = `
    ${renderSingleCollapsible("The Experience", feel)}
    ${renderSingleCollapsible("When To Wear", whenToWear)}
    ${renderSingleCollapsible("Product Description", description)}
    ${renderSingleCollapsible("Shipping & Returns", shipping)}
  `;
}

  function getCardCount(variantId) {
    return selected.filter((p) => String(p.id) === String(variantId)).length;
  }

  function renderCardActions(card) {
    const config = offers[currentOffer];
    const variantId = card.dataset.variantId;
    const count = getCardCount(variantId);
    const bundleFull = selected.length >= config.required;
    const actionsEl = card.querySelector(".card-actions");
    if (!actionsEl) return;

    if (count > 0) {
      const canAdd = !bundleFull && !config.special;

      actionsEl.innerHTML = `
        <button class="view-details-btn" type="button">Details</button>
        <div class="bundle-stepper">
          <button class="stepper-btn stepper-minus" type="button" aria-label="Remove one">−</button>
          <span class="stepper-count">${count}</span>
          <button class="stepper-btn stepper-plus" type="button" aria-label="Add one" ${canAdd ? "" : "disabled"}>+</button>
        </div>
      `;
    } else {
      const sizeTakenInSpecial =
        config.special &&
        selected.map((p) => p.size).includes(normalizeSize(card.dataset.size));

      const disabled = bundleFull || sizeTakenInSpecial;

      actionsEl.innerHTML = `
        <button class="view-details-btn" type="button">View Details</button>
        <button class="add-to-bundle" type="button" ${disabled ? "disabled" : ""}>Add to Bundle</button>
      `;
    }

    card.classList.toggle("is-added", count > 0);
    card.classList.toggle("is-blocked", count === 0 && bundleFull);
  }

  function updateUI() {
    const config = offers[currentOffer];

    if (progress) progress.innerText = `${selected.length} / ${config.required} selected`;
    if (bundlePrice) bundlePrice.innerText = config.price;
    if (bundleMrp) bundleMrp.innerText = config.mrp;
    if (bundleSavings) bundleSavings.innerText = config.savings;
    if (checkoutBtn) checkoutBtn.disabled = selected.length !== config.required;

    document.querySelectorAll(".bundle-card").forEach((card) => {
      if (card.style.display === "none") return;
      renderCardActions(card);
    });

    if (modal && modal.dataset.openVariant) {
      const v = modal.dataset.openVariant;
      const mSize = normalizeSize(modal.dataset.size);
      const mAddedCount = selected.filter((p) => String(p.id) === String(v)).length;
      const bundleFull = selected.length >= config.required;

      let dis = bundleFull;
      if (!dis && config.special) {
        dis = selected.map((p) => p.size).includes(mSize) || mAddedCount > 0;
      }

      if (modalAddBtn) {
        modalAddBtn.disabled = dis;

        if (mAddedCount > 0 && config.special) modalAddBtn.textContent = "Added ✓";
        else if (bundleFull) modalAddBtn.textContent = "Bundle Full";
        else modalAddBtn.textContent = "Add to Bundle";
      }
    }
  }

  function renderBasketSlots() {
    const config = offers[currentOffer];
    if (!basket) return;

    basket.innerHTML = "";

    for (let i = 0; i < config.required; i++) {
      const slot = document.createElement("div");
      slot.classList.add("basket-slot");
      slot.innerHTML = `
        <div class="basket-slot-image">
          <span class="slot-empty">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </span>
        </div>
      `;
      basket.appendChild(slot);
    }
  }

  function rebuildBasketFromSelected() {
    renderBasketSlots();
    if (!basket) return;

    const slots = basket.querySelectorAll(".basket-slot");

    selected.forEach((item, i) => {
      const slot = slots[i];
      if (!slot) return;

      slot.dataset.filled = "true";
      slot.innerHTML = `
        <div class="basket-slot-image">
          <img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}" />
        </div>
        <button class="remove-from-bundle" type="button" title="Remove">Remove</button>
      `;

      const removeBtn = slot.querySelector(".remove-from-bundle");
      if (removeBtn) {
        removeBtn.addEventListener("click", () => {
          selected.splice(i, 1);
          rebuildBasketFromSelected();
          updateUI();
        });
      }
    });
  }

  function filterVariants() {
    const config = offers[currentOffer];
    const allowedSizes = config.sizes.map(normalizeSize);

    selected = [];
    renderBasketSlots();

    const hint = document.getElementById("bundle-repeat-hint");
    if (hint) hint.style.display = config.special ? "none" : "";

    document.querySelectorAll(".bundle-card").forEach((card) => {
      const size = normalizeSize(card.dataset.size);
      card.style.display = allowedSizes.includes(size) ? "" : "none";
      card.classList.remove("is-added", "is-blocked");

      const notesEl = card.querySelector(".card-notes-list");
      if (notesEl) {
        notesEl.innerHTML = renderNotesListHTML(card.dataset.notes, 3);
      }

      const actionsEl = card.querySelector(".card-actions");
      if (actionsEl) {
        actionsEl.innerHTML = `
          <button class="view-details-btn" type="button">View Details</button>
          <button class="add-to-bundle" type="button">Add to Bundle</button>
        `;
      }
    });

    updateUI();
  }

  function openModal(card) {
    if (!modal) return;

    const variantId = card.dataset.variantId;
    const gallery = safeParseGallery(card.dataset.gallery || "");

    renderModalGallery(
      gallery,
      card.dataset.imageHd || card.dataset.image || "",
      card.dataset.title || ""
    );

    if (modalTitle) modalTitle.textContent = card.dataset.title || "";
    if (modalSize) modalSize.textContent = card.dataset.size || "";
    if (modalDesc) modalDesc.textContent = card.dataset.description || "";

    if (modalStars) {
      const ratingHTML = renderStarsHTML(
        card.dataset.rating,
        card.dataset.ratingCount,
        card.dataset.ratingScale
      );
      modalStars.innerHTML = ratingHTML;
      modalStars.style.display = ratingHTML ? "" : "none";
    }

    if (modalNotes) {
      const noteHTML = renderNotesModalHTML(card.dataset.notes || "");
      modalNotes.innerHTML = noteHTML;
      modalNotes.style.display = noteHTML ? "" : "none";
    }

    renderModalCollapsibles(card);

    modal.dataset.openVariant = variantId;
    modal.dataset.variantId = variantId;
    modal.dataset.image = card.dataset.image || "";
    modal.dataset.title = card.dataset.title || "";
    modal.dataset.size = card.dataset.size || "";
    modal.dataset.productId = card.dataset.productId || "";

    const config = offers[currentOffer];
    const mSize = normalizeSize(card.dataset.size);
    const addedCount = selected.filter((p) => String(p.id) === String(variantId)).length;
    const bundleFull = selected.length >= config.required;

    let dis = bundleFull;
    if (!dis && config.special) {
      dis = selected.map((p) => p.size).includes(mSize) || addedCount > 0;
    }

    if (modalAddBtn) {
      modalAddBtn.disabled = dis;
      if (addedCount > 0 && config.special) modalAddBtn.textContent = "Added ✓";
      else if (bundleFull) modalAddBtn.textContent = "Bundle Full";
      else modalAddBtn.textContent = "Add to Bundle";
    }

    modal.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove("open");
    document.body.style.overflow = "";
    modal.dataset.openVariant = "";
  }

  function addVariantFromCard(card) {
    const variantId = card.dataset.variantId;
    const config = offers[currentOffer];

    if (selected.length >= config.required) return;
    if (config.special && selected.some((p) => String(p.id) === String(variantId))) return;

    selected.push({
      id: variantId,
      productId: card.dataset.productId || "",
      size: normalizeSize(card.dataset.size),
      image: card.dataset.image || "",
      title: card.dataset.title || ""
    });

    rebuildBasketFromSelected();
    updateUI();
    showToast("Added to your bundle!");
  }

  function removeOneVariant(variantId) {
    const index = selected.findIndex((p) => String(p.id) === String(variantId));
    if (index === -1) return;

    selected.splice(index, 1);
    rebuildBasketFromSelected();
    updateUI();
  }

  offerButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      offerButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      currentOffer = btn.dataset.offer;
      filterVariants();
    });
  });

  if (modalClose) modalClose.addEventListener("click", closeModal);

  if (modal) {
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });

  document.addEventListener("click", function (e) {
    const toggle = e.target.closest(".modal-collapsible-toggle");
    if (!toggle) return;

    const item = toggle.closest(".modal-collapsible");
    if (!item) return;

    const isOpen = item.classList.contains("is-open");
    item.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");

    const icon = item.querySelector(".modal-collapsible-icon");
    if (icon) {
      icon.textContent = isOpen ? "+" : "−";
    }
  });

  if (modalAddBtn) {
    modalAddBtn.addEventListener("click", () => {
      const variantId = modal.dataset.variantId;
      const image = modal.dataset.image;
      const size = normalizeSize(modal.dataset.size);
      const title = modal.dataset.title;
      const config = offers[currentOffer];

      if (selected.length >= config.required) return;
      if (config.special && selected.some((p) => String(p.id) === String(variantId))) return;

      selected.push({
        id: variantId,
        productId: modal.dataset.productId || "",
        size,
        image,
        title
      });

      rebuildBasketFromSelected();
      updateUI();
      closeModal();
      showToast(`${title} added to your bundle!`);
    });
  }

  if (productGrid) {
    productGrid.addEventListener("click", function (e) {
      const card = e.target.closest(".bundle-card");
      if (!card || card.style.display === "none") return;

      const addBtn = e.target.closest(".add-to-bundle");
      if (addBtn) {
        e.stopPropagation();
        if (addBtn.disabled) return;
        addVariantFromCard(card);
        return;
      }

      const plusBtn = e.target.closest(".stepper-plus");
      if (plusBtn) {
        e.stopPropagation();
        if (plusBtn.disabled) return;
        addVariantFromCard(card);
        return;
      }

      const minusBtn = e.target.closest(".stepper-minus");
      if (minusBtn) {
        e.stopPropagation();
        removeOneVariant(card.dataset.variantId);
        return;
      }

      const detailsBtn = e.target.closest(".view-details-btn");
      if (detailsBtn) {
        e.stopPropagation();
        openModal(card);
        return;
      }

      openModal(card);
    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", () => {
      const config = offers[currentOffer];

      if (config.special) {
        const has20 = selected.some((p) => p.size === "20ml");
        const has100 = selected.some((p) => p.size === "100ml");

        if (!has20 || !has100) {
          showToast("Please select one 20ml and one 100ml.", "error");
          return;
        }
      }

      const items = selected.map((p) => ({ id: p.id, quantity: 1 }));

      checkoutBtn.disabled = true;
      checkoutBtn.textContent = "Adding…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      })
        .then((res) => {
          if (!res.ok) throw new Error("Cart error");
          return res.json();
        })
        // AFTER
.then(() => {
  showToast(`Bundle added! Redirecting…`, "success");
  checkoutBtn.textContent = "Added ✓";
  document.dispatchEvent(new CustomEvent("cart:refresh"));

  setTimeout(() => {
    window.location.href = "/cart";
  }, 800);
})
        .catch((err) => {
          console.error(err);
          showToast("Something went wrong. Please try again.", "error");
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = "Checkout";
        });
    });
  }

  filterVariants();
});